// extracted by mini-css-extract-plugin
export default {"label":"ExteriorColorSelector-module__label--uJgqH"};